import React, { useEffect, useRef, useState } from "react";
import pinkspin from "../Image/pinkSpin.png";
import purplespin from "../Image/purpleSpin.png";
import spincircle from "../Image/spinCircle.png";
import spinbtn from "../Image/spinButton.png";
import winnerImg from "../Image/gameWinImg.png";
import looserImg from "../Image/gameLoseImg.png";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import bitcoin from "../Image/bitcoin.png";

function Spinwheel({ setOpenLogin, isAuth }) {
  const [isSpin, setIsSpin] = useState(false);
  const [selectColor, setSelectColor] = useState("");
  const [rotation, setRotation] = useState(0);
  const [gameResult, setGameResult] = useState(null);
  const [tableData, setTableData] = useState([]);

  const { wallet, setWallet } = useAuth();

  const rotationRef = useRef(0);

  const wheelSegments = [
    "purple",
    "pink",
    "purple",
    "pink",
    "purple",
    "pink",
    "purple",
    "pink",
    "purple",
    "pink",
    "purple",
    "pink",
    "purple",
    "pink",
    "purple",
    "pink",
  ];

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("SpinwheelData")) || [];

    setTableData(storedData);

    const loadWallet = () => {
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};

      setWallet(currentUser?.wallet ? parseFloat(currentUser.wallet) : 0);
    };

    loadWallet();
  }, [isAuth, setWallet]);

  const spinWheel = (data) => {
    const betAmount = parseFloat(data.amount);

    if (!isAuth) {
      setOpenLogin(true);
      return;
    }

    if (!selectColor) {
      toast.error("Please Select a Color");
      return;
    }

    if (betAmount <= 0) {
      toast.error("Enter amount greater than 0");
      return;
    }

    if (betAmount > wallet) {
      toast.error("Insufficient Wallet Balance");
      return;
    }

    if (isSpin) return;

    setIsSpin(true);

    setGameResult(null);

    const totalSegments = wheelSegments.length;

    const degreesPerSegment = 360 / totalSegments;

    const winningIndex = Math.floor(Math.random() * wheelSegments.length);

    const resultColor = wheelSegments[winningIndex];

    const targetAngle =  winningIndex * degreesPerSegment + degreesPerSegment / 2;

    const wheelOffset = 0;

    const finalAngle = 360 - targetAngle - wheelOffset;

    const extraSpins = 360 * 6;

    const newRotation = rotationRef.current + extraSpins + finalAngle;

    rotationRef.current = newRotation;

    setRotation(newRotation);

    setTimeout(() => {
      setIsSpin(false);

      let finalResult = "";

      let finalWallet = wallet;

      if (selectColor === resultColor) {
        finalResult = "winner";

        setGameResult("winner");

        finalWallet = wallet + betAmount * 2;
      } else {
        finalResult = "looser";

        setGameResult("looser");

        finalWallet = wallet - betAmount;
      }

      setWallet(finalWallet);

      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};

      currentUser.wallet = finalWallet;

      localStorage.setItem("currentUser", JSON.stringify(currentUser));

      const users = JSON.parse(localStorage.getItem("user")) || [];

      const updatedUsers = users.map((user) => {
        if (user.email === currentUser.email) {
          return {
            ...user,
            wallet: finalWallet,
          };
        }

        return user;
      });

      localStorage.setItem("user", JSON.stringify(updatedUsers));

      const newGameData = {
        email: currentUser?.email || "Guest",

        selectColor: selectColor,

        betAmount: betAmount,

        winAmount: finalResult === "winner" ? betAmount * 2 : 0,

        result: finalResult,
      };

      setTableData((prev) => {
        const updatedData = [...prev, newGameData];

        localStorage.setItem("SpinwheelData", JSON.stringify(updatedData));

        return updatedData;
      });

      reset();

      setTimeout(() => {
        setRotation(rotationRef.current + 360);

        setTimeout(() => {
          const wheel = document.querySelector(".spin-circle");

          if (wheel) {
            wheel.style.transition = "none";
          }

          setRotation(0);

          rotationRef.current = 0;

          setTimeout(() => {
            if (wheel) {
              wheel.style.transition = "transform 5s ease-out";
            }
          }, 50);
        }, 100);
      }, 2000);
    }, 5000);
  };
  return (
    <div className="spingame-section">
      <div className="container">
        <div className="dicegame-wrapper">
          {gameResult && (
            <div className="result-popup">
              <img
                src={gameResult === "winner" ? winnerImg : looserImg}
                alt={gameResult}
                className="result-status-img"
              />

              <button onClick={() => setGameResult(null)}>Close</button>
            </div>
          )}

          <form
            onSubmit={
              isAuth
                ? handleSubmit(spinWheel)
                : (e) => {
                    e.preventDefault();
                    setOpenLogin(true);
                  }
            }
          >
            <div className="spin-wrapper-inner">
              <div className="d-flex justify-content-center align-items-center gap-3 spin-color">
                <img
                  src={pinkspin}
                  alt="pinkspin"
                  onClick={() => setSelectColor("pink")}
                  className={selectColor === "pink" ? "active-bet1" : ""}
                />

                <img
                  src={purplespin}
                  alt="purplespin"
                  onClick={() => setSelectColor("purple")}
                  className={selectColor === "purple" ? "active-bet1" : ""}
                />
              </div>

              <div className="amount-field mt-3">
                <div
                  className="bet-input-wrapper d-flex align-items-center"
                  style={{
                    backgroundColor: "#092a69",
                  }}
                >
                  <div className="d-flex align-items-center">
                    <img src={bitcoin} alt="bitcoin" height={24} />
                  </div>

                  <input
                    type="number"
                    step="any"
                    placeholder="Enter Your Bet Amount"
                    className="amount-input"
                    {...register("amount", {
                      required: "Amount is required",

                      validate: (value) =>
                        parseFloat(value) > 0 ||
                        "Amount must be greater than 0",
                    })}
                  />
                </div>

                {errors.amount && (
                  <p className="error-text">{errors.amount.message}</p>
                )}
              </div>

              <button type="submit" className="spin-btn" disabled={isSpin}>
                {!isAuth ? "LOGIN TO PLAY" : isSpin ? "SPIN..." : "SPIN WHEEL"}
              </button>
            </div>
          </form>

          <div className="spinwheel-bg-wrapper">
            <div className="spin-bg d-flex justify-content-center">
              <div className="d-flex justify-content-center align-items-center spin-inner">
                <div>
                  <img src={pinkspin} alt="pinkspin" className="color-img" />
                </div>

                <div className="spin-circle-wrapper">
                  <img src={spinbtn} alt="spinbtn" className="Spinpin" />

                  <img
                    src={spincircle}
                    alt="spincircle"
                    className="spin-circle"
                    style={{
                      transform: `rotate(${rotation}deg)`,
                      transition: "transform 5s ease-out",
                    }}
                  />
                </div>

                <div>
                  <img
                    src={purplespin}
                    alt="purplespin"
                    className="color-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 gametable-responsive-wrapper">
          <table className="game-table">
            <thead>
              <tr>
                <th>Player Email</th>
                <th>Selected Colors</th>
                <th>Bet Amount</th>
                <th>Win Amount</th>
                <th>Result</th>
              </tr>
            </thead>

            <tbody>
              {tableData.length > 0 ? (
                tableData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.email}</td>

                    <td>{item.selectColor}</td>

                    <td>{item.betAmount}</td>

                    <td>{item.winAmount ? item.winAmount : "-"}</td>

                    <td>{item.result === "winner" ? "Winner" : "Looser"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    No Game Played Yet
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Spinwheel;
